<template>
  <div class="modal fade" id="waypoint-options-dialog" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="modal-content">
        <div class="modal-body p-0">
          <template v-if="topPageIsWaypointOptions">
            <WaypointDialogOptions/>
          </template>
          <template v-if="topPageIsWaypointGroups">
            <WaypointDialogWaypointGroups/>
          </template>
          <template v-if="topPageIsWaypointGroupsWaypoints">
            <WaypointDialogWaypointGroupWaypoints/>
          </template>
          <template v-if="topPageIsWaypointViewDetails">
            <WaypointDialogViewWaypointDetails/>
          </template>
          <template v-if="topPageIsWaypointEditDetails">
            <WaypointDialogEditWaypointDetails/>
          </template>
          <template v-if="topPageIsWaypoints">
            <WaypointDialogWaypoints/>
          </template>
          <template v-if="topPageIsWaypointGroupSelection">
            <WaypointDialogWaypointGroupSelection/>
          </template>

          <div class="waypoint-dialog__footer">
            <button
              type="button"
              class="btn waypoint-dialog__close"
              data-bs-dismiss="modal"
              aria-label="Close"
            >
              Close
            </button>
          </div>

        </div>
      </div>
    </div>
    <LoadingDialog :show-loading-dialog="loading"/>
  </div>
</template>

<script>

import { defineComponent } from 'vue';
// eslint-disable-next-line import/extensions,import/no-unresolved
import { mapGetters, mapState } from 'vuex';
import LoadingDialog from '../../utils/shared_components/LoadingDialog.vue';
import WaypointDialogEditWaypointDetails from './components/WaypointDialogEditWaypointDetails.vue';
import WaypointDialogOptions from './components/WaypointDialogOptions.vue';
import WaypointDialogViewWaypointDetails from './components/WaypointDialogViewWaypointDetails.vue';
import WaypointDialogWaypointGroups from './components/WaypointDialogWaypointGroups.vue';
import WaypointDialogWaypointGroupSelection from './components/WaypointDialogWaypointGroupSelection.vue';
import WaypointDialogWaypointGroupWaypoints from './components/WaypointDialogWaypointGroupWaypoints.vue';
import WaypointDialogWaypoints from './components/WaypointDialogWaypoints.vue';

export default defineComponent({
  components: {
    LoadingDialog,
    WaypointDialogWaypoints,
    WaypointDialogWaypointGroupWaypoints,
    WaypointDialogWaypointGroups,
    WaypointDialogEditWaypointDetails,
    WaypointDialogViewWaypointDetails,
    WaypointDialogOptions,
    WaypointDialogWaypointGroupSelection,
  },
  mounted() {

  },
  computed: Object.assign(mapGetters({
    topPageIsWaypointOptions: 'waypoints/topPageIsWaypointOptions',
    topPageIsWaypointViewDetails: 'waypoints/topPageIsWaypointViewDetails',
    topPageIsWaypointEditDetails: 'waypoints/topPageIsWaypointEditDetails',
    topPageIsWaypoints: 'waypoints/topPageIsWaypoints',
    topPageIsWaypointGroups: 'waypoints/topPageIsWaypointGroups',
    topPageIsWaypointGroupsWaypoints: 'waypoints/topPageIsWaypointGroupsWaypoints',
    topPageIsWaypointGroupSelection: 'waypoints/topPageIsWaypointGroupSelection',
  }), mapState({
    loading: (state) => state.waypoints.loading,
  })),
});
</script>

<style scoped>
.modal-content {
  /* `hidden` (not just overflow-x) so each page's header background follows the
     dialog's rounded corners. */
  overflow: hidden !important;
}

.waypoint-dialog__footer {
  padding: 0 1rem 1rem;
}

.waypoint-dialog__close {
  width: 100%;
  background: var(--gray);
  border: 1px solid var(--gray-border);
  color: var(--text-muted);
  font-weight: 600;
}

.waypoint-dialog__close:hover {
  background: var(--highlight);
  color: #fff;
}
</style>
